import { PartiallyConstructible } from '../utils';
import { PageData } from './PageData';
/**
Document Data
*/
export class DocumentData extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentData>`} */
    constructor(source = {}) {
        super();
        /**
          The maximum size of the document image
          Default is 0
          */
        this.documentImageSizeLimit = 0;
        if (source.uuid !== undefined) {
            this.uuid = source.uuid;
        }
        else {
            throw new Error('uuid must be present in constructor argument');
        }
        if (source.creationTimestamp !== undefined) {
            this.creationTimestamp = source.creationTimestamp;
        }
        else {
            throw new Error('creationTimestamp must be present in constructor argument');
        }
        if (source.pages !== undefined) {
            this.pages = source.pages.map(it => new PageData(it));
        }
        else {
            throw new Error('pages must be present in constructor argument');
        }
        if (source.documentImageSizeLimit !== undefined) {
            this.documentImageSizeLimit = source.documentImageSizeLimit;
        }
        if (source.pdfURI !== undefined) {
            this.pdfURI = source.pdfURI;
        }
        else {
            throw new Error('pdfURI must be present in constructor argument');
        }
        if (source.tiffURI !== undefined) {
            this.tiffURI = source.tiffURI;
        }
        else {
            throw new Error('tiffURI must be present in constructor argument');
        }
    }
}
//# sourceMappingURL=DocumentData.js.map